import styled, { css } from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

const displayGrid = css`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  grid-row-gap: 0.5rem;
  grid-template-areas:
    'display title'
    'display content';
`;

const loadingGrid = css`
  display: grid;
  grid-template-columns: 1fr;
`;

const errorGrid = displayGrid;

export default styled.div`
  position: relative;
  border: 1px solid ${lightGrey2Color};
  background: white;
  border-radius: 0.25rem;
  ${({ mode }) => (mode === 'display' ? displayGrid : mode === 'error' ? errorGrid : loadingGrid)}

  a {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: block;
  }
`;
